declare global {
  interface Window {
    ttq?: {
      page: (...args: any[]) => void;
      track: (event: string, payload?: Record<string, any>) => void;
      identify: (payload: Record<string, any>) => void;
      ready?: (cb: () => void) => void; // present on recent SDKs
    };
  }
}

export type TikTokEvent =
  | 'ViewContent'
  | 'CompleteRegistration'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'InitiateCheckout'
  | 'Purchase';

const withTTQ = (cb: (ttq: NonNullable<typeof window.ttq>) => void) => {
  if (typeof window === 'undefined') return;
  const { ttq } = window;
  if (!ttq) return;

  cb(ttq);
};

export const ttqTrack = (event: TikTokEvent, payload?: Record<string, any>) => {
  withTTQ((ttq) => ttq.track(event, payload));
};

export const ttqIdentify = (payload: { email?: string }) => {
  withTTQ((ttq) => ttq.identify(payload));
};

export const ttqPage = () => {
  withTTQ((ttq) => ttq.page());
};
